const authConstant = require("./constant");
const axios = require("axios").default;
const _ = require("lodash");
const moment = require("moment");

const getLiveVehicleTrack = async (vid) => {
  const authToken = localStorage.getItem("auth-token");
  const response = await axios.post(
    authConstant.MAIN_URI,
    {
      name: "getLiveByVechicle",
      param: {
        usr: localStorage.getItem("username"),
        vid,
        edt: moment().format("YYYY-MM-DD"),
        tz: "Asia/Kolkata",
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return _.result(response.data, "response.result.ldata") ? _.result(response.data, "response.result.ldata")[0] : [];
};

export default getLiveVehicleTrack;
